import { useDispatch, useSelector } from "react-redux";
import SelectDropdown from "../../../components/dropdown/selectdropdown/SelectDropdown";
import { useEffect } from "react";
import Label from "../../../components/label/Label";
import RichGrid from "../../../components/richgrid/RichGrid";
import styles from "../statefilinghistory/StateFilingHistory.styles";
import useGarbageCollector from "../../../../libs/garbagecollector/garbageCollectorHooks";
import { HEADING } from "../../../components/heading/constants/constants";
import Heading from "../../../components/heading/Heading";
import useTxNavigate from "../../../../libs/txnavigate/TxNavigateHook";
import { LABEL_WEIGHT } from "../../../components/label/constants";
import { componentKey, setSelectedState, setFormList, setSelectedForm, setSelectedTaxYear, setSelectedPayer, setPayerList, setStatePayrollHistoryGridData, setRowsPerPage, setSkip, setSelectedStatePayrollHistoryGridData, setUrlFormIdParam, setUrlPayerIdParam } from "./StatePayrollFilingHistorySlice";
import { getStatePayrollHistoryStates, getStatePayrollHistoryForms, getStatePayrollHistoryPayers, getStatePayrollHistoryGrid } from "./StatePayrollFilingHistorySaga";
import Loadable from "../../../components/loadable/Loadable";
import { QUERY_PARAMS, FORM_SECTION_ROUTES } from "../../formssection/constants";
import { HISTORY_LOADING_STATES, HISTORY_MESSAGE_MAP } from "../Constants";
import { ROW_SELECTION_OPTIONS } from "../../../components/richgrid/constants";
import useTxSearchParams from "../../../../libs/txsearchparams/TxSearchParamsHook";

export default function StatePayrollFilingHistory() {

    useGarbageCollector(componentKey)

    const { stateList, selectedState, formList, selectedForm, taxYearList, selectedTaxYear, payerList, selectedPayer, statePayrollHistoryGridData, selectedStatePayrollHistoryGridData, rowsPerPage, skip, loadingState, urlFormIdParam, urlPayerIdParam } = useSelector(state => state[componentKey]);

    const dispatch = useDispatch();
    const [queryParams, setQueryParams] = useTxSearchParams();
    const navigate = useTxNavigate();

    useEffect(() => {
        const stateParamFromUrl = queryParams.get(QUERY_PARAMS.STATE_ID)
        const formIdParamFromUrl = queryParams.get(QUERY_PARAMS.FORM_ID)
        const taxYearParamFromUrl = queryParams.get(QUERY_PARAMS.TAX_YEAR)
        const payerIdParamFromUrl = queryParams.get(QUERY_PARAMS.PAYER_ID)

        dispatch(setUrlFormIdParam(formIdParamFromUrl))
        dispatch(setUrlPayerIdParam(payerIdParamFromUrl))
        dispatch(getStatePayrollHistoryStates({ urlStateParam: stateParamFromUrl, urlTaxYearParam: taxYearParamFromUrl }));
    }, [])

    useEffect(() => {
        if (selectedState?.value) {
            dispatch(getStatePayrollHistoryForms({ stateNames: selectedState?.value, urlFormIdParam: urlFormIdParam }));
        } else {
            dispatch(setFormList([]));
        }
        dispatch(setSelectedForm({ label: "", value: "" }))

    }, [selectedState])

    useEffect(() => {
        if (selectedForm?.value) {
            dispatch(getStatePayrollHistoryPayers({ formId: selectedForm?.value, urlPayerIdParam: urlPayerIdParam }));
        }
        dispatch(setPayerList([]));
        dispatch(setSelectedPayer({ label: "", value: "" }))

    }, [selectedForm])

    useEffect(() => {
        if (selectedState?.value && selectedForm?.label && selectedTaxYear?.value && selectedPayer?.value) {
            dispatch(getStatePayrollHistoryGrid({ PageSize: rowsPerPage, PageNumber: (skip / rowsPerPage) + 1, taxYear: selectedTaxYear?.value, formId: selectedForm?.label, payerId: selectedPayer?.value }))
        } else {
            dispatch(setStatePayrollHistoryGridData([]));
            dispatch(setSelectedStatePayrollHistoryGridData([]));
        }
    }, [rowsPerPage, skip, selectedForm, selectedTaxYear, selectedPayer])

    const handleFilterChange = (name, selectedOption) => {
        switch (name) {
            case 'stateName':
                dispatch(setSelectedState({ ...selectedOption }))
                break;
            case 'formName':
                dispatch(setSelectedForm({ ...selectedOption }))
                break;
            case 'taxYear':
                dispatch(setSelectedTaxYear({ ...selectedOption }))
                break;
            case 'payer':
                dispatch(setSelectedPayer({ ...selectedOption }))
                break;
        }
    }

    const STATE_PAYROLL_FILING_HISTORY_COLUMNS = [
        {
            field: "ReferenceNo",
            header: <Label weight={LABEL_WEIGHT[700]}>Reference Number</Label>,
            renderLogic: (row, idx) => <span style={{ ...styles.text }}>{row?.StatePayrollReferenceNumber || "-"}</span>
        },
        {
            field: "formName",
            header: <Label weight={LABEL_WEIGHT[700]}>Form Name</Label>,
            renderLogic: (row, idx) => <span style={{ ...styles.text }}>{row?.FormName || "-"}</span>
        },
        {
            field: "tIN",
            header: <Label weight={LABEL_WEIGHT[700]}>Payer TIN</Label>,
            renderLogic: (row, idx) => <span style={{ ...styles.text }}>{row?.PayerIdNumber || "-"}</span>
        },
        {
            field: "status",
            header: <Label weight={LABEL_WEIGHT[700]}>Status</Label>,
            renderLogic: (row, idx) => <span style={{ ...styles.text }}>{row?.Status || "-"}</span>
        },
        {
            field: "eFileDate",
            header: <Label weight={LABEL_WEIGHT[700]}>eFile Date</Label>,
            renderLogic: (row, idx) => <span style={{ ...styles.text }}>{row?.EfileDate || "-"}</span>
        },
        {
            field: "viewLink",
            header: <Label weight={LABEL_WEIGHT[700]}>Action</Label>,
            renderLogic: (row, idx) => {
                const navigateUrl = `/${FORM_SECTION_ROUTES.FORMS}/${FORM_SECTION_ROUTES.MANAGE}/${FORM_SECTION_ROUTES.STATE_PAYROLL_FORMS}?${QUERY_PARAMS.STATE_ID}=${selectedState?.value}&${QUERY_PARAMS.FORM_ID}=${selectedForm?.value}&${QUERY_PARAMS.TAX_YEAR}=${selectedTaxYear?.value}&${QUERY_PARAMS.PAYER_ID}=${selectedPayer?.value}`;
    
                const handleClick = () => {
                    navigate(navigateUrl);
                };
    
                return (
                    <span>
                        <span
                            style={{ ...styles.refColor, ...styles.linkHover }}
                            onClick={handleClick}
                        >
                            Click here
                        </span> to View.
                    </span>
                );
            }
        },
    ]

    return (
        <>
            <Heading type={HEADING.H1}>State Payroll Filing History</Heading>
            <div style={styles.filterRow}>
                <div>
                    <Loadable
                        currentState={loadingState.state}
                        loadingStates={[HISTORY_LOADING_STATES.FETCHING_STATES_LIST_LOADING]}
                        messageMap={HISTORY_MESSAGE_MAP}
                        isNewLoadable={true}
                        isFullWidth={false}
                    ><label>State</label>
                        <SelectDropdown
                            name="stateName"
                            value={{ label: selectedState.label, value: selectedState.value }}
                            prefixProps={{ text: "" }}
                            onSelectCb={(name, selectedOption) => {
                                handleFilterChange(name, selectedOption);
                                dispatch(setSelectedState(selectedOption));
                                if (selectedOption?.value) {
                                    queryParams.set(QUERY_PARAMS.STATE_ID, selectedOption?.value);
                                } else {
                                    queryParams.delete(QUERY_PARAMS.STATE_ID);
                                }
                                setQueryParams(queryParams);
                            }}
                            options={stateList}
                        />
                    </Loadable>
                </div>
                <div>
                    <Loadable
                        currentState={loadingState.state}
                        loadingStates={[HISTORY_LOADING_STATES.FETCHING_FORMS_LIST_LOADING]}
                        messageMap={HISTORY_MESSAGE_MAP}
                        isNewLoadable={true}
                        isFullWidth={false}
                    >
                        <label>Form</label>
                        <SelectDropdown
                            name="formName"
                            value={{ label: selectedForm.label, value: selectedForm.value }}
                            prefixProps={{ text: "" }}
                            onSelectCb={(name, selectedOption) => {
                                handleFilterChange(name, selectedOption);
                                dispatch(setSelectedForm(selectedOption));
                                if (selectedOption?.value) {
                                    queryParams.set(QUERY_PARAMS.FORM_ID, selectedOption?.value)
                                } else {
                                    queryParams.delete(QUERY_PARAMS.FORM_ID)
                                }
                                setQueryParams(queryParams);
                            }}
                            options={formList}
                        />
                    </Loadable>
                </div>
                <div>
                    <label>Tax Year</label>
                    <SelectDropdown
                        name="taxYear"
                        value={{ label: selectedTaxYear.label, value: selectedTaxYear.value }}
                        onSelectCb={(name, selectedOption) => {
                            handleFilterChange(name, selectedOption);
                            dispatch(setSelectedTaxYear(selectedOption));
                            if (selectedOption?.value) {
                                queryParams.set(QUERY_PARAMS.TAX_YEAR, selectedOption?.value)
                            } else {
                                queryParams.delete(QUERY_PARAMS.TAX_YEAR)
                            }
                            setQueryParams(queryParams);
                        }}
                        options={taxYearList}
                    />
                </div>
                <div>
                    <Loadable
                        currentState={loadingState.state}
                        loadingStates={[HISTORY_LOADING_STATES.FETCHING_PAYERS_LIST_LOADING]}
                        messageMap={HISTORY_MESSAGE_MAP}
                        isNewLoadable={true}
                        isFullWidth={false}
                    >
                        <label>Payer</label>
                        <SelectDropdown
                            name="payer"
                            value={{ label: selectedPayer.label, value: selectedPayer.value }}
                            onSelectCb={(name, selectedOption) => {
                                handleFilterChange(name, selectedOption);
                                dispatch(setSelectedPayer(selectedOption));
                                if (selectedOption?.value) {
                                    queryParams.set(QUERY_PARAMS.PAYER_ID, selectedOption?.value)
                                } else {
                                    queryParams.delete(QUERY_PARAMS.PAYER_ID)
                                }
                                setQueryParams(queryParams);
                            }}
                            options={payerList}
                        />
                    </Loadable>
                </div>
            </div>
            <Loadable currentState={loadingState.state} loadingStates={HISTORY_LOADING_STATES.FETCHING_GRID_RECORDS_LOADING} messageMap={HISTORY_MESSAGE_MAP} isNewLoadable={true}>
                <div style={styles.grid}>
                    <RichGrid
                        data={statePayrollHistoryGridData}
                        columns={STATE_PAYROLL_FILING_HISTORY_COLUMNS}
                        selectable={false}
                        extractRowKey={(row) => row.FormId}
                        paginationProps={{
                            skip: skip,
                            take: rowsPerPage,
                            takeOptions: ROW_SELECTION_OPTIONS,
                            onChangeTakeCb: (newTake) => {
                                dispatch(setRowsPerPage(newTake));
                                dispatch(setSkip(0))
                            },
                            total: selectedStatePayrollHistoryGridData,
                            onChange: (take, t) => {
                                dispatch(setRowsPerPage(take));
                                dispatch(setSkip(t))
                            },
                        }}
                    />
                </div>
            </Loadable>
        </>
    )
}